import { ProductName } from './graphql-client/graphql';

export abstract class Environment {
  abstract readonly production: boolean;
  abstract readonly product: ProductName;
  abstract readonly api: string;
  abstract readonly pdfApi: string;
  abstract readonly emailApi: string;
}
